import type { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useComparePeriodSelectorStyles = makeStyles((theme: Theme) => ({
    light: {
        color: theme.palette.grey[600],
        fontSize: 12,
    },
    container: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
}));
